import axios from 'axios'
import {
  MessageBox,
  Form
} from 'element-ui'
import {
  showLoading,
  hideLoading
} from './loading';
import ElementUI from 'element-ui';

// axios.defaults.baseURL = 'http://api.course.t.mifengdao.com'

import appConfig from './appConfig'
axios.defaults.baseURL = appConfig.baseUrl;
// axios.defaults.baseURL = 'http://api.course.mifengdao.com'
var token = getToken();
if (!token) {
  if (process.env.NODE_ENV == 'development') {
    token = appConfig.development_token
  } else {
    goLogin();
    // Toast({
    //   message: '登录已经失效、请重新登录',
    //   onClose:
    // });
  }
}
console.log('token', token);
isMobile();
// 添加axios的请求拦截器，
axios.interceptors.request.use(function (config) {
  //   let cookie = localStorage.getItem('cookie')
  //   if (cookie) {
  //     config.url = config.url + ';jsessionid=' + cookie
  //   }
  config.headers['token'] = token
  // 这个请求对象必须return回去，不然请求不会继续发送

  if (config.headers.isLoading !== false) {
    // 如果配置了isLoading: false，则不显示loading
    showLoading();
  }
  return config
}, function (error) {
  // 返回请求错误信息的函数
  MessageBox.error({
    message: '请求超时!'
  })
  return Promise.reject(error)
})

axios.interceptors.response.use((res) => {
  setTimeout(() => {
    hideLoading()
  }, 500);
  // if (res.data.code === 1000) {
  //   // window.history.go(-1);

  // } else if (res.data.code === 401) {
  //   console.log('登录失效');
  //   goLogin();
  // } else if (res.data.code === 1004) {
  //   ElementUI.MessageBox({
  //     title: '提示',
  //     message: '您还没购买该课程',
  //     callback: action => {
  //       if(res.data.data.goods_id===0){
  //         window.history.go(-1);
  //       }else{
  //         window.location.href =res.data.data.redirect_url
  //       }
  //     }
  //   });
  // } else if (res.data.code === 1005) {
  //   ElementUI.MessageBox({
  //     title: '提示',
  //     message: '您的课程已经过期请联系客服'
  //   });
  // }

  switch(res.data.code){
    case 401 :
    localStorage.removeItem('userinfo')
      ElementUI.MessageBox({
          title: '提示',
          message: '您的登录已经失效！',
          callback: goLogin()
        });
    break ;
    case 402 :
      localStorage.removeItem('userinfo')
      ElementUI.MessageBox({
          title: '提示',
          message: '您还未绑定手机',
          callback: action =>{
            goBindInfo()
          }
        });
      hideLoading()
    break ;
    case 1000:  //普通异常
      ElementUI.MessageBox({
        title: '提示',
        message: res.data.msg
      });
    break ;
    case 1004 :
      ElementUI.MessageBox({
        title: '提示',
        message: '您还没购买该课程',
        callback: action => {
          if(res.data.data.goods_id===0){
            window.history.go(-1);
          }else{
            let url=appConfig.ShoppUrl+'/goods/'+res.data.data.goods_id
            window.location.href =url
          }
        }
      });
    break ;
    case 1005 :
      ElementUI.MessageBox({
        title: '提示',
        message:  res.data.msg
      });
    break ;

  }


  return res
}, function (err) {
  console.log('登录失效', err);
  // token 已过期，重定向到登录页面
  if ((err.response.status === 401) && (process.env.NODE_ENV != 'development')) {

    goLogin();



  }
  return Promise.reject(err)
})



// axios.interceptors.response.use((response) => {
//   console.log('登录失效') ;
//   return response
// }, (err) => {
//   return Promise.reject(err)
// })

// 获取商城顶部分类列表接口
export const categoryListTop = () => axios.get(`${appConfig.ShoppUrl}/api_shop/get_category_list_top`).then(res => res.data.data)
//通过课时类型获取课时内容
export const levelContent = (course_id,level_id) => axios.get(`/v1/chapter/level_content/${course_id}/${level_id}`).then(res => res.data.data)
// 课程列表0全部1考证2实操3免费4最近//废弃参数
export const Course = (expire_time) => axios.get('/v1/course',{
  params:{
    classify:1,
    expire_time:expire_time?expire_time:0
  }
}).then(res => res.data.data)
//  猜你喜欢
export const Guess = obj => axios.get('/v1/course/guess',{
  params:obj
}).then(res => res.data.data)
//  直播预告
export const Notice = () => axios.get('/v1/live/notice').then(res => res.data.data)
//  上次播放记录
export const Previous = () => axios.get('/v1/video/previous').then(res => res.data.data)
//  科目标题
export const ClassTitle = id => axios.get(`/v1/course/${id}/subject`).then(res => res.data.data)
//  商城题库分类和题库首页
export const QuestionClass = (course_id, chapter_id) => axios.get(`/v1/question/question_class/?course_id=${course_id}&chapter_id=${chapter_id}`).then(res => res.data.data)
// 课程考试时间
export const ExamTime = id => axios.get(`/v1/course/${id}/exam_time`).then(res => res.data.data)
// 科目详情
export const ClassList = (id, course_id) => axios.get(`/v1/chapter/${id}/${course_id}`).then(res => res.data.data)
// 科目详情（单课程）
export const oneClassList = (id, course_id) => axios.get(`/v1/chapter/${id}/${course_id}`).then(res => res.data.data)
// 做题
// 试题列表
export const Questions = (course_id, chapter_id) => axios.get('/v1/learn', {
  params: {
    course_id: course_id,
    chapter_id: chapter_id
  }
}).then(res => res.data.data)
// 试题列表子目录
export const Queschild = (course_id, id) => axios.get('/v1/learn/chapterChild', {
  params: {
    course_id: course_id,
    id: id
  }
}).then(res => res.data.data)

// 题目列表
export const Work = obj => axios.get('/v1/learn/exercise', {
  params: obj
}).then(res => res.data.data)
// 我的错题
export const Wrong = id => axios.get('/v1/learn/wrongQuestions', {
  params: {
    subject_id: id
  }
}).then(res => res.data.data)
// 练习模式保存结果
export const SaveResult = obj => axios.post('/v1/learn/saveResult', obj, {
  headers: {
    isLoading: false
  }
}).then(res => res.data.data)
// 提问提交
export const SaveComment = obj => axios.post('/v1/comment', obj, {
  headers: {
    isLoading: false
  }
}).then(res => res)
// 删除我的错题
export const DeleteWrong = (question_id,subject_id,type) => axios.get('/v1/learn/deleteWrongQuestion', {
  params: {
    question_id: question_id,
    subject_id:subject_id,
    type:type
  },
  headers: {
    isLoading: false
  }
}).then(res => res)

// 收藏题目
export const SaveFavorite = id => axios.get('/v1/learn/saveFavorite', {
  params: {
    question_id: id
  },
  headers: {
    isLoading: false
  }
}).then(res => res)

// 讲义下载
// 科目列表
export const DocSubject = (chapter_id, course_id) => axios.get(`/v1/doc/${chapter_id}/subject/${course_id}`).then(res => res.data.data)
// 讲义列表
export const Doc = id => axios.get('/v1/doc', {
  params: {
    chapter_id: id
  }
}).then(res => res.data.data)
// 讲义详情
export const DocDetail = id => axios.get(`/v1/doc/${id}`).then(res => res.data.data)

// 我的收藏
export const Favorite = id => axios.get('/v1/learn/favoriteQuestions', {
  params: {
    subject_id: id
  },
  headers: {
    isLoading: false
  }
}).then(res => res.data.data)
// 题目列表练习模式
export const Exercise = obj => axios.get('/v1/learn/exercise', {
  params: obj
}).then(res => res.data.data)
// 视频(回放)列表
export const Video = id => axios.get('/v1/video', {
  params: {
    id: id
  }
}).then(res => res.data.data)
// 视频(回放)详情
export const VideoDtail = id => axios.get(`/v1/video/${id}`).then(res => res)
// 获取观看进度
export const Videoprogress = chapter_id => axios.get(`/v1/progress/${chapter_id}`, {
  headers: {
    isLoading: false
  }
}).then(res => res)
export const VideoError = obj => axios.post('/v1/video/videoError', obj, {
    headers: {
        isLoading: false
    }
}).then(res => res)
// 我的提问
export const MyComments = obj => axios.get('/v1/learn/myComments', {
  params: obj,
  headers: {
    isLoading: true
  }
}).then(res => res.data.data)
// 提问详情
export const CommentsInfo = (id, type) => axios.get('/v1/learn/commentsInfo', {
  params: {
    source_id: id,
    source_type: type
  }
}).then(res => res)
// 保存观看进度
export const Progress = obj => axios.post('/v1/progress', obj, {
  headers: {
    isLoading: false
  }
}).then(res => res)
// 考试题目
export const Exam = obj => axios.get('/v1/learn/exercise', {
  params: obj
}).then(res => res.data.data)
// 保存考试结果
export const SaveExam = obj => axios.post('/v1/learn/testpaperSaveResult', obj, {
  headers: {
    isLoading: false
  }
}).then(res => res.data.data)
// 课程表
export const Schedule = () => axios.get('/v1/course/schedule').then(res => res.data.data)
// 报告详情
export const ExamResult = obj => axios.get('/v1/learn/examResult', {
  params: obj
}).then(res => res.data.data)
// 我的作业
export const Task = obj => axios.get('/v1/work', {
  params: obj
}).then(res => res.data.data)
// 加入班群
export const Join = (id, course_id) => axios.get(`/v1/chapter/${id}/class_group/${course_id}`).then(res => res.data.data)
// 作业题目
export const TaskList = obj => axios.get('/v1/work/getWorks', {
  params: obj
}).then(res => res.data.data)
// 作业保存答案
export const SaveTaskList = obj => axios.get('/v1/work/saveWorkResult', {
  params: obj,
  headers: {
    isLoading: false
  }
}).then(res => res.data.data)
// 获取首页作业状态
export const WorkStatus = () => axios.get('/v1/work/getWorkStatus').then(res => res.data.data)
// 获取面包屑
export const Crumbs = (course_id, cid) => axios.get('/v1/learn/crumbs', {
  params: {
    course_id: course_id,
    cid: cid
  }
}).then(res => res.data.data)

// 获取用户信息
export const Userinfo = () => axios.get('/v1/user/getUserInfo').then(res => res.data.data)
// 是否有实操模块
export const HasShicao = () => axios.get(appConfig.shicaoUrl+'/has_shicao').then(res => res.data.data)
// 获取广告数据
export const billing = (id,course_id) => axios.get('/v1/course/ad',
{
  params:{
    ad_id:id,
    course_id:course_id
  }
}
).then(res => res.data.data)
// 主观题打分接口
export const SaveScores = obj => axios.post('/v1/learn/saveScores', obj,{
  headers: {
    isLoading: false
  }
}).then(res => res.data.data)

// 过期课程收起接口
export const updateCourseExpireTimeStatus = obj => axios.post('/v1/course/update_course_expire_time_status', obj, {
  headers: {
    isLoading: true
  }
}).then(res => res.data)
// 学习记录
export const exerciseRecord = (course_id) => axios.get(`/v1/learn/exercise_record?course_id=${course_id}`).then(res => res.data)
export const historyMock = (course_id) => axios.get(`/v1/learn/history_mock?course_id=${course_id}`).then(res => res.data)
// 隐藏首页播放记录
export const delPrevious = () => axios.get(`/v1/video/del_previous`).then(res => res.data)
// 知识点列表
export const knowledgeList = (subject_id) => axios.get(`/v1/learn/knowledgeList?subject_id=${subject_id}`).then(res => res.data)
// 回顾考点
export const knowledgeVideo = (id) => axios.get(`/v1/knowledgeVideo/${id}`).then(res => res.data)
// 题目视频讲解
export const questionVideo = (id) => axios.get(`/v1/questionVideo/${id}`).then(res => res.data)
// 知识点报告 
export const knowledgeReport = (knowledge_id) => axios.get(`/v1/learn/knowledgeReport/${knowledge_id}`).then(res => res.data)
// 知识点讲义
export const knowledgeDoc = (id) => axios.get(`/v1/learn/knowledgeDoc/${id}`).then(res => res.data)
// 视频三级列表
export const thirdLayer = (chapter_id) => axios.get(`/v1/thirdLayer/${chapter_id}`).then(res => res.data)
// 轻课模拟考试列表
export const aiMock = (chapter_id) => axios.get(`/v1/learn/ai_mock?chapter_id=${chapter_id}`).then(res => res.data)
// 轻课考试练习列表
export const aiChapterExam = (chapter_id) => axios.get(`/v1/learn/ai_chapter_exam?chapter_id=${chapter_id}`).then(res => res.data)











function getToken() {
  // var KJ_env = 'KJ_env';

  // var sso_token_key = 'sso_token_' + getCookie(KJ_env);

  var token = getCookie(appConfig.sso_token);

  return token;
}

function getCookie(cookie_name) {
  var allcookies = document.cookie;

  //索引长度，开始索引的位置
  var cookie_pos = allcookies.indexOf(cookie_name);
  var value = '';
  // 如果找到了索引，就代表cookie存在,否则不存在
  if (cookie_pos != -1) {
    // 把cookie_pos放在值的开始，只要给值加1即可
    //计算取cookie值得开始索引，加的1为“=”
    cookie_pos = cookie_pos + cookie_name.length + 1;
    //计算取cookie值得结束索引
    var cookie_end = allcookies.indexOf(";", cookie_pos);

    if (cookie_end == -1) {
      cookie_end = allcookies.length;

    }
    //得到想要的cookie的值
    value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}


function goLogin() {
  var redirect = encodeURIComponent(window.location.href);
  //判断是否为微信
  if (isWeiXin()) {
    window.location.href = appConfig.passportUrl + "/wechat_open/authorize?redirect=" + redirect;
    return;
  } else {
    var sUserAgent = navigator.userAgent.toLowerCase();
    if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
      //跳转移动端页面
      window.location.href = appConfig.passportUrl + "/passport/loginFast?redirect=" + redirect;
      return;
    } else {
      //跳转pc端页面
      window.location.href = appConfig.passportUrl + "/login?redirect=" + redirect;
      return;
    }
  }

}
function goBindInfo(){
  //跳转绑定手机页面
  var redirect = encodeURIComponent(window.location.href);
  window.location.href = appConfig.passportUrl+"/bindAccountFast?redirect="+redirect;
}
//判断是否微信登陆
function isWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  console.log(ua); //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}


//如果是PC端就跳回PC端
function isMobile() {

  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    // window.location.href = "https://www.baidu.com/";
    //移动端
    console.log('移动端');
    var url_str = window.location.href;
    if (url_str.indexOf('/pc/') != -1) { //查找是否是蜜蜂岛PC端
      window.location.href = url_str.replace("/pc/", "/m/");
    }

  } else {
    console.log('PC端');
    //PC端
    var url_str = window.location.href;
    if (url_str.indexOf('/m/') != -1) { //查找是否是蜜蜂岛PC端
      window.location.href = url_str.replace("/m/", "/pc/");
    }

  }


}
